import React, { Component } from 'react';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { CommonValidationMessages } from '../../../utils/Messages';
import { CityMasterPopup } from './CityMasterTable';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class CityMaster extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            cityObject: {
                idCity: 0,
                updateStatus: 0,
                idCountry: 0,
                idState: 0,
                cityName: "",
                remarks: "",
                e_Date: "",
                countryList: [],
                stateList: [],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                idCountry: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "country"
                        ),
                    },
                ],
                idState: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "state"
                        ),
                    },
                ],
                cityName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "city"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getMasterCitySelectbyId(event.data.idCity);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.cityObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.cityObject;
        details[name] = value;
        this.setState({ cityObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let cityObject = this.state.cityObject;
        cityObject.idCity = 0;
        cityObject.updateStatus = 0;
        cityObject.idCountry = 0;
        cityObject.idState = 0;
        cityObject.cityName = "";
        cityObject.remarks = "";
        cityObject.e_Date = "";
        cityObject.stateList = [];
        this.setState({
            cityObject: cityObject, validState: validState
        });
    }

    handleChangeFroDropdown = (event, name) => {
        //debugger;
        let details = this.state.cityObject;
        let value = event.value;
        details[name] = value;
        this.setState({ cityObject: details }, () => {
            if (name === 'idCountry') {
                this.getAllDropdownForAccountMaster(value)
            }
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdownForAccountMaster(0);
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    getAllDropdownForAccountMaster = (id) => {
        let request = [this.state.idCompany, id];
        this.accountMasterServices.getAllDropdownForAccountMaster(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.cityObject;
                if (id > 0) {
                    data.idState = 0;
                    data.stateList = allData.filter(item => item.source === 'Master_State');
                } else {
                    data.countryList = allData.filter(item => item.source === 'Master_Country');
                }
                //data.selectProcessList = allData.filter(item => item.source === 'Master_Process');
                this.setState({
                    cityObject: data
                });
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "City Master",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idCity"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                            //   ? (params) => {
                            //     if (!params.value) return "";
                            //     return moment(params.value).format("DD-MM-YYYY");
                            //   }
                            //   : undefined,
                            //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                        }));
                        //const priorityColumn = "bankName"; // Replace with the actual column name
                        //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                        //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                        //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                        // const updatedColDefs = [
                        //   ...pinnedColumns,
                        //   ...(priorityColDef ? [priorityColDef] : []),
                        //   ...otherColumns,
                        // ];
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs, //updatedColDefs,
                            caption: "City Master",
                            colName: colName
                        }, () => {
                            //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                            //this.getAllDropdownForEmployeeMaster();
                            this.setPermissions(permissions);
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            //this.gridApi.hideOverlay();
                            //this.gridApi.showNoRowsOverlay();
                            //this.getAllDropdownForEmployeeMaster();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        this.setState({
            permissions: {
                isAddEdit: permissions.add,
                isDelete: permissions.delete,
                isView: permissions.view,
            }
        });
    };

    getColumnWidth = (key) => {
        const colwidth = {
            "sR.No": window.innerWidth * 0.05,
            "countryName": window.innerWidth * 0.1,
            "stateName": window.innerWidth * 0.2,
            "cityName": window.innerWidth * 0.2,
            "remarks": window.innerWidth * 0.1,
        }
        return colwidth[key]
    }

    getMasterExpenseAccGroupCount = () => {
        this.accountMasterServices.getMasterExpenseAccGroupCount(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0].count;
                let cityObject = this.state.cityObject
                cityObject.accGrpNo = data + 1;
                this.setState({
                    cityObject: cityObject
                });
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let details = this.state.cityObject;
            let requestData = {
                idCity: details.idCity,
                idCountry: details.idCountry,
                idState: details.idState,
                cityName: details.cityName,
                remarks: details.remarks,
                idCompany: this.state.idCompany,
                e_Date: details.e_Date && details.e_Date !== 'Invalid date' ? details.e_Date : new Date().toISOString(),
                isDeleted: false,
                deletedDate: null,
            };
            this.accountMasterServices.submitCityMaster(requestData)
                .then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (response.responseItem?.responseContent?.errorType === 'Exists') {
                                this.SwalServices.Error("City master are already exists.");
                            } else {
                                if (this.state.cityObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                // Call resetFields here after submission
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP(); // Fetch latest records
                                    }
                                );
                            }

                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                });
        }
    };

    getMasterCitySelectbyId = (id) => {
        this.accountMasterServices.getMasterCitySelectbyId(id).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let cityObject = this.state.cityObject;
                let responseData = response.responseItem.responseContent[0];
                if (responseData) {
                    cityObject.idCity = responseData.idCity;
                    cityObject.updateStatus = 1;
                    cityObject.idCountry = responseData.idCountry;
                    cityObject.idState = responseData.idState;
                    cityObject.cityName = responseData.cityName;
                    cityObject.remarks = responseData.remarks;
                    cityObject.e_Date = responseData.e_Date;
                    cityObject.stateList = [];
                }
                this.setState({
                    cityObject: cityObject,
                    isModalOpen: true
                }, () => {
                    let request = [responseData.idCompany, responseData.idCountry];
                    this.accountMasterServices.getAllDropdownForAccountMaster(request).then((response2) => {
                        //debugger
                        if (response2.statusCode == 200 && response2.responseItem !== null) {
                            let allData = response2.responseItem.responseContent;
                            let data = this.state.cityObject;
                            if (id > 0) {
                                data.stateList = allData.filter(item => item.source === 'Master_State');
                                data.idState = responseData.idState;
                            }
                            this.setState({
                                cityObject: data
                            });
                        }
                    });
                });
            }
        });
    }

    render() {
        return (
            <div className='company-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <CityMasterPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            cityObject={this.state.cityObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                            validState={this.state.validState}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">City master</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}